export default __webpack_public_path__ + "static/media/caret-right.a2c7722a.svg";